export const cylinderReweighReasons = [
    { label: 'Error', value: 1 },
    { label: 'Wrong Read', value: 2 },
    { label: 'End of Calendar Year Weighing', value: 3 },
];